/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_State_DraftInputs */

const en_wb_state_draft = /** @type {(inputs: Wb_State_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Draft prepared. Waiting for a person.`)
};

const lv_wb_state_draft = /** @type {(inputs: Wb_State_DraftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Melnraksts sagatavots. Gaida cilvēku.`)
};

/**
* | output |
* | --- |
* | "Draft prepared. Waiting for a person." |
*
* @param {Wb_State_DraftInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_state_draft = /** @type {((inputs?: Wb_State_DraftInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_State_DraftInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_state_draft(inputs)
	return en_wb_state_draft(inputs)
});